import Axios from '../lib/axios';

/**
 * Fetches manual bonuses with pagination and optional search
 * @param params Object containing page, pageSize, and search string
 */
const GetManualBonuses = (params: { page: number; pageSize: number; search?: string }): any => {
  return Axios.get(`${process.env.REACT_APP_SERVER_ROOT || ''}/manual-bonus`, { params });
};

/**
 * Gets a specific manual bonus by ID
 * @param manualBonusId The manual bonus ID
 */
const GetManualBonus = (manualBonusId: string): any => {
  return Axios.get(`${process.env.REACT_APP_SERVER_ROOT || ''}/manual-bonus/${manualBonusId}`);
};

/**
 * Creates a new manual bonus entry
 * @param bonus The manual bonus data
 */
const CreateManualBonus = (bonus: any): any => {
  return Axios.post(`${process.env.REACT_APP_SERVER_ROOT || ''}/manual-bonus`, bonus);
};

/**
 * Updates an existing manual bonus entry
 * @param manualBonusId The manual bonus ID to update
 * @param bonus The updated manual bonus data
 */
const EditManualBonus = (manualBonusId: string, bonus: any): any => {
  return Axios.put(`${process.env.REACT_APP_SERVER_ROOT || ''}/manual-bonus/${manualBonusId}`, bonus);
};

/**
 * Send email notification for an existing manual bonus entry
 * @param manualBonusId The manual bonus ID to update
 */
const SendEmailNotificationBonus = (manualBonusIds: string[]): any => {
  return Axios.post(`${process.env.REACT_APP_SERVER_ROOT || ''}/manual-bonus/notify`, { manualBonusIds });
};

/**
 * Deletes a manual bonus entry
 * @param manualBonusId The manual bonus ID to delete
 */
const DeleteManualBonus = (manualBonusId: string): any => {
  return Axios.delete(`${process.env.REACT_APP_SERVER_ROOT || ''}/manual-bonus/${manualBonusId}`);
};

const ManualBonusService = {
  GetManualBonuses,
  GetManualBonus,
  CreateManualBonus,
  EditManualBonus,
  SendEmailNotificationBonus,
  DeleteManualBonus,
};

export default ManualBonusService;
